import { createContext } from "react";

export type ScreenType = "sm" | "lg" | "xl";

const ScreenContext = createContext<ScreenType>("lg");

export default ScreenContext;
